<template>
    <el-dialog :title="(formData.edit? $t('Update Spender'):$t('Create Spender'))" :visible.sync="dialogFormVisible"
        :before-close="handleClose" @open="handleOpen('formData')">
        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('First Name')" prop="first_name">
                    <el-input v-model="formData.first_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Last Name')" prop="last_name">
                    <el-input v-model="formData.last_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Company name')" prop="company_name">
                    <el-input v-model="formData.company_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Email')" prop="email">
                    <el-input v-model="formData.email"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Phone')" prop="phone">
                    <el-input v-model="formData.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Address')" prop="address">
                    <vue-google-autocomplete :country="['ch', 'so', 'iq']" v-model="formData.address" id="map"
                        classname="el-input__inner" ref="address" placeholder="Start typing" v-on:placechanged="getAddressData"
                        @change="handleAddressChange"></vue-google-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Place')" prop="place">
                    <el-input v-model="formData.place"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Zipcode')" prop="zipcode">
                    <el-input v-model="formData.zipcode"></el-input>
                </el-form-item>
            </el-col>
            
            <input type="hidden" v-model="formData.latitude" name="latitude">
            <input type="hidden" v-model="formData.longitude" name="longitude">
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">{{ (formData.edit?
                        $t('Update'):$t('Save')) }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        components: {
            VueGoogleAutocomplete
        },
        props: {
            dialogFormVisible: Boolean,
            rowData: Object,
            accountGroups: Object,
            accountClasses: Object
        },
        data() {
            return {
                formData: {},
                formLabelWidth: '120px',
                rules: {
                    // email: [{
                    //     required: true,
                    //     message: this.$t('This field is required'),
                    //     trigger: ['blur']
                    // }, {
                    //     type: 'email',
                    //     message: 'Please input correct email address',
                    //     trigger: ['blur', 'change']
                    // }]
                }
            };
        },
        methods: {
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                    this.$refs.address.update(this.formData.address);
                })
            },
            handleClose() {
                this.$emit('popup', false)
            },
            handleAddressChange(address) {
                this.formData.address = address;
                this.$refs['formData'].validateField('address');
            },
            getAddressData: function (addressData, placeResultData, id) {
                this.formData.address = placeResultData.formatted_address;
                this.formData.place = placeResultData.vicinity;
                this.formData.zipcode = addressData.postal_code;
                this.formData.latitude = addressData.latitude;
                this.formData.longitude = addressData.longitude;
            },
            updateData(row) {
                return request({
                        url: "spenders/" + row.id,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: "spenders",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('popup', false);
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .el-radio-group label {
        padding: 0;
        text-transform: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/Layout/Spenders/Form.vue